import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";

export default function LoadingIndicator() {
	return (
		<Box sx={{ p: 5, m: 5, textAlign: "center" }}>
			<CircularProgress size="5rem" />
		</Box>
	);
}
